module.exports = __webpack_public_path__ + "static/media/mulher_r1_c7.d6dc9d36.jpg";